import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
	textareaLineNumbers: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[100]),
		"& > div": {
			paddingLeft: theme.spacing(0.5),
			paddingRight: theme.spacing(0.5)
		},
		"& textarea": {
			textAlign: "center",
			color: colors.gray[900]
		},
		"& fieldset": {
			border: 0
		}
	},
	tabs: {
		position: "relative",
		"&::before": {
			content: "close-quote",
			position: "absolute",
			width: "100%",
			height: "1px",
			bottom: 0,
			left: 0,
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[200])
		}
	},
	tab: {
		color: `${colors.gray[700]} !important`,
		opacity: 1,
		fontSize: 14,
		textAlign: "start"
	},
	tabIndicator: {
		...ColorUtil.getBackgroundAndContrastColor(colors.getPrimaryColor())
	},
	scrollBar: {
		maxHeight: 186,
		overflowY: "auto",
		width: "100%",
		"&::-webkit-scrollbar": {
			width: "0.3em"
		},
		"&::-webkit-scrollbar-track": {
		},
		"&::-webkit-scrollbar-thumb": {
			border: "none",
			outline: 1,
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[100])
		},
		margin: "15px 0"
	}
}))

export default useStyles
